import {Heading} from "@/components/ui/heading";
import {Button} from "@/components/ui/button";
import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import Paths from "../../constants/Paths";

const SectionBoxes = () => {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState({});

    const toggleExpand = (index) => {
        setExpanded((prev) => ({...prev, [index]: !prev[index]}));
    };

    return (
        <section id="about" className="py-14">
            <div className="section-content generic-container">
                <div className="text-center md:text-left">
                    <div style={{textAlign: 'center'}}>
                        <Heading level={2} className={`gradient-header`}>
                            Locked Trade is an educational platform,<span className="break-line">&nbsp;</span>
                            a set of tools, and a community that will help you unlock<span
                            className="break-line">&nbsp;</span>
                            the potential of capital markets<span className="break-line">&nbsp;</span>
                            and take your investments to the next level.
                        </Heading>
                    </div>

                    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-24`} style={{ marginTop: '45px', marginBottom: '50px' }}>
                        {[
                            {
                                title: "AI Assistant",
                                content: "Discover the future of trading with our advanced tool that supports you in market analysis and delivers personalized investment signals in real-time.",
                                img: require('assets/images/box1.jpg'),
                                href: Paths.VIRTUAL_ASSISTANT,
                                targetBlank: false,
                            },
                            {
                                title: "Educational Platform",
                                content: "Expand your knowledge of financial markets with courses and educational materials designed for both beginner and advanced traders.",
                                img: require('assets/images/box2.jpg'),
                                href: Paths.TRAINING,
                                targetBlank: false,
                            },
                            {
                                title: "Trader Community",
                                content: "Join a group of enthusiasts on our Discord channel, where we share experiences, strategies, and support each other in striving for success.",
                                img: require('assets/images/box3.jpg'),
                                href: Paths.DISCORD,
                                targetBlank: true,
                            }
                        ].map((box, index) => (
                            <div key={index} className={`flex flex-col box--item`}>
                                <Link to={box.href} target={box.targetBlank ? "_blank" : "_self"}>
                                    <Heading level={3} className={`box--title`}>
                                        {box.title}
                                    </Heading>
                                </Link>
                                <p className={`box--content ${expanded[index] ? 'expanded' : ''}`}>
                                    <Link to={box.href} target={box.targetBlank ? "_blank" : "_self"}>
                                        {box.content}
                                    </Link>
                                    {!expanded[index] && (
                                        <span className="show-more" onClick={() => toggleExpand(index)}>Show more</span>
                                    )}
                                </p>
                                <Link to={box.href} target={box.targetBlank ? "_blank" : "_self"} className="box--image--container">
                                    <img src={box.img} alt={`img${index + 1}`} className="box--image"/>
                                </Link>
                            </div>
                        ))}
                    </div>

                    <div className={`text-center`}>
                        <Link to={Paths.ABOUT} className="big-button dark-variant mx-auto mt-3">ABOUT US</Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SectionBoxes;